

















import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { SimpleLookupItem } from '../models/SimpleLookupItem'
import IcnRegion from './IcnRegion.vue'
import IcnIndustry from './IcnIndustry.vue'

@Component({
  components: {
    IcnRegion,
    IcnIndustry
  },
  name: 'IcnOpportunities'
})
export default class IcnOpportunities extends Vue {
  parameters = {
    state: ''
  }

  searchType = 'all_opportunities'
  subRegions: SimpleLookupItem[] = []

  private async getSubRegionAsync (): Promise<SimpleLookupItem[]> {
    const apiUrl = '/Umbraco/Api/ICNGateway/GetSubRegions'
    const response = await axios.post(`${process.env.VUE_APP_BASE_URL}${apiUrl}`, this.parameters)
    return response.data
  }

  getSubRegions (): void {
    this.getSubRegionAsync().then((response) => {
        this.subRegions = response
      })
      .catch((error) => {
        console.log(error)
      })
      // .then(() => {
      // })
  }
}
